<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col  :md="6" :sm="24">
              <a-form-item :label="$t('类型')" prop="type">
                <a-select :placeholder="$t('请选择')+$t('类型')" style="width: 100%" v-model="queryParam.videoType" allowClear>
                  <a-select-option v-for="(item, index) in customDict.VideoTypeEnum" :value="item.type+''" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="videoTitle">
                <span slot="label" ><a-tooltip>{{$t('视频标题')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.videoTitle" :maxLength="32" :placeholder="$t('请输入')+$t('视频标题')" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="videoStatus">
                <a-select :placeholder="$t('请选择')+$t('状态')" style="width: 100%" v-model="queryParam.videoStatus" allowClear>
                  <a-select-option v-for="(item, index) in customDict.VideoStatusEnum" :value="item.type+''" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['community:communityvideo:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>-->
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['community:communityvideo:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="handleAudit()" v-hasPermi="['community:communityvideo:edit']">
          <a-icon type="audit" />{{$t('审核')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['community:communityvideo:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['community:communityvideo:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList"/>
      <audit-form ref="auditForm" @ok="handleAuditOk"/>
      <detail-form ref="detailForm"/>
      <reply-list ref="replyList"/>
      <contents-form ref="contentsForm"/>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="videoStatus" slot-scope="text, record">
           <custom-dict-tag :options="customDict.VideoStatusEnum" :value="record.videoStatus"/>
        </span>
        <template slot="videoUrlList" slot-scope="text, record">
          <div
            v-if="record.videoUrlList && record.videoUrlList.length"
            class="moments-grid"
            :class="'moments-grid--' + getGridCount(record.videoUrlList)"
          >
            <div
              v-for="(url, idx) in record.videoUrlList"
              :key="idx"
              class="moments-grid__item"
              @click="handleRecordPreview(record.videoUrlList,record.videoType)"
            >
              <img v-if="record.videoType===2" :src="url" :alt="'图片' + (idx + 1)" />
              <video  v-if="record.videoType===1" style="width: 100%;height: 100%"   :poster="record.videoPic">
                <source :src="url" type="video/mp4">
              </video>
            </div>
          </div>
          <span v-else>-</span>
        </template>
        <span slot="videoType" slot-scope="text, record">
           <custom-dict-tag :options="customDict.VideoTypeEnum" :color="true" :value="record.videoType"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleAudit(record)" v-hasPermi="['community:communityvideo:edit']">
             <a-icon type="audit" />{{$t('审核')}}
          </a>
          <a-divider type="vertical"  />
          <a @click="$refs.detailForm.handleUpdate(record)" >
             <a-icon type="edit" />{{$t('详情')}}
          </a>
          <a-divider type="vertical"  />
          <a @click="$refs.replyList.getList(record.id)" >
             <a-icon type="edit" />{{$t('评论列表')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['community:communityvideo:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['community:communityvideo:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCommunityVideo,listCommunityVideo, delCommunityVideo } from '@/api/community/video'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import AuditForm from './modules/AuditForm'
import DetailForm from './modules/DetailForm'
import ContentsForm from './modules/ContentsForm'
import ReplyList from './modules/ReplyList'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CommunityVideo',
  components: {
    CustomDictTag,
    CreateForm,
    AuditForm,
    ContentsForm,
    ReplyList,
    DetailForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        videoTitle: undefined,
        videoContent: undefined,
        videoPic: undefined,
        videoUrl: undefined,
        videoType: undefined,
        videoDuration: undefined,
        videoStatus: undefined,
        relationId: undefined,
        playsNum: undefined,
        likesNum: undefined,
        shareNum: undefined,
        replyNum: undefined,
        auditReason: undefined,
        atUser: undefined,
        isNeedPay: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('视频标题'),
          width: '25%',
          dataIndex: 'videoTitle',
          align: 'left'
        },
        {
          title: this.$t('视频缩略图'),
          dataIndex: 'videoUrlList',
          scopedSlots: { customRender: 'videoUrlList' },
          align: 'center',
          width: 200
        },
        {
          title: this.$t('类型'),
          dataIndex: 'videoType',
          scopedSlots: { customRender: 'videoType' },
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'videoStatus',
          scopedSlots: { customRender: 'videoStatus' },
          align: 'center'
        },
        {
          title: this.$t('用户编号'),
          dataIndex: 'userId',
          align: 'center'
        },
        {
          title: this.$t('用户昵称'),
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: this.$t('点赞次数'),
          dataIndex: 'starNum',
          align: 'center'
        },
        {
          title: this.$t('分享次数'),
          dataIndex: 'shareNum',
          align: 'center'
        },
        {
          title: this.$t('被评论数量'),
          dataIndex: 'replyNum',
          align: 'center'
        },
        {
          title: this.$t('审核意见'),
          dataIndex: 'auditReason',
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询视频列表 */
    getList () {
      this.loading = true
      pageCommunityVideo(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        videoTitle: undefined,
        videoContent: undefined,
        videoPic: undefined,
        videoUrl: undefined,
        videoType: undefined,
        videoDuration: undefined,
        videoStatus: undefined,
        relationId: undefined,
        playsNum: undefined,
        likesNum: undefined,
        shareNum: undefined,
        replyNum: undefined,
        auditReason: undefined,
        atUser: undefined,
        isNeedPay: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    /** 获取数量用于 grid class (1-9) */
    getGridCount(urlList) {
      return Math.min(Math.max(urlList.length, 1), 9)
    },
    handleRecordPreview(list,videoType) {
      this.$refs.contentsForm.handleContent(list, videoType);
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 审核按钮操作 */
    handleAudit (row) {
      const ids = row && row.id ? [row.id] : this.ids
      if (!ids.length) {
        this.$message.warning(this.$t('请选择要审核的数据'))
        return
      }
      this.$refs.auditForm.handleAudit(ids)
    },
    handleAuditOk () {
      this.onSelectChange([], [])
      this.getList()
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delCommunityVideo(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('community/admin/community/video/export',
            that.queryParam
            , `视频_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* 微信朋友圈风格九宫格 - 使用 grid 确保正确排列 */
.moments-grid {
  display: grid;
  gap: 4px;
  width: fit-content;
  min-width: 60px;

  &__item {
    overflow: hidden;
    background: #f5f5f5;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  /* 1图：单图大一点 */
  &--1 {
    grid-template-columns: 80px;
    grid-template-rows: 80px;
  }

  /* 2图：横排2张 */
  &--2 {
    grid-template-columns: repeat(2, 60px);
  }

  /* 3图：横排3张 */
  &--3 {
    grid-template-columns: repeat(3, 60px);
  }

  /* 4图：2x2 四宫格 */
  &--4 {
    grid-template-columns: repeat(2, 88px);
  }

  /* 5-9图：3列网格 微信朋友圈布局 */
  &--5,
  &--6,
  &--7,
  &--8,
  &--9 {
    grid-template-columns: repeat(3, 50px);
  }
}
</style>